import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import API from
  "../../utils/apiCalling";

import {
  config,
} from "../../utils/apiUrl";


const api =
  new API({
    tokenKey:
      "platformAccessToken",
  });


const initialState = {
  tickets:
    [],

  selectedTicket:
    null,

  summary: {
    total:
      0,

    NEW:
      0,

    OPEN:
      0,

    IN_PROGRESS:
      0,

    WAITING_CUSTOMER:
      0,

    RESOLVED:
      0,

    CLOSED:
      0,
  },

  filters: {
    page:
      1,

    limit:
      20,

    search:
      "",

    status:
      "",

    priority:
      "",

    category:
      "",

    tenantId:
      "",

    fromDate:
      "",

    toDate:
      "",
  },

  pagination: {
    page:
      1,

    limit:
      20,

    total:
      0,

    totalPages:
      1,
  },

  filterOptions: {
    statuses:
      [],

    priorities:
      [],

    categories:
      [],

    tenants:
      [],
  },

  listLoading:
    false,

  detailsLoading:
    false,

  actionLoading:
    false,

  error:
    null,
};


const qs =
  (
    params = {}
  ) => {

    const searchParams =
      new URLSearchParams();


    Object.entries(
      params
    ).forEach(
      ([
        key,
        value,
      ]) => {

        if (
          value !==
            undefined &&
          value !==
            null &&
          value !==
            ""
        ) {

          searchParams.append(
            key,
            value
          );

        }

      }
    );


    return searchParams
      .toString();
  };


const normalizeError =
  (
    error
  ) => ({
    message:
      error?.response
        ?.data
        ?.message ||
      error?.response
        ?.message ||
      error?.message ||
      "Something went wrong.",
  });


export const fetchPlatformSupportTickets =
  createAsyncThunk(
    "platformSupport/list",

    async (
      params = {},
      {
        rejectWithValue,
      }
    ) => {

      try {

        const query =
          qs(
            params
          );


        return await api.get(
          query
            ?
            `${config.platformSupportTickets}?${query}`
            :
            config.platformSupportTickets,

          true
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          normalizeError(
            error
          )
        );

      }

    }
  );


export const fetchPlatformSupportSummary =
  createAsyncThunk(
    "platformSupport/summary",

    async (
      _,
      {
        rejectWithValue,
      }
    ) => {

      try {

        return await api.get(
          config
            .platformSupportSummary,

          true
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          normalizeError(
            error
          )
        );

      }

    }
  );


export const fetchPlatformSupportFilters =
  createAsyncThunk(
    "platformSupport/filters",

    async (
      _,
      {
        rejectWithValue,
      }
    ) => {

      try {

        return await api.get(
          config
            .platformSupportFilters,

          true
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          normalizeError(
            error
          )
        );

      }

    }
  );


export const fetchPlatformSupportById =
  createAsyncThunk(
    "platformSupport/details",

    async (
      id,
      {
        rejectWithValue,
      }
    ) => {

      try {

        return await api.get(
          config
            .platformSupportById(
              id
            ),

          true
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          normalizeError(
            error
          )
        );

      }

    }
  );


const createUpdateThunk =
  (
    type,
    getUrl,
    buildPayload
  ) =>
    createAsyncThunk(
      type,

      async (
        args,
        {
          rejectWithValue,
        }
      ) => {

        try {

          const {
            id,
          } =
            args;


          return await api.patch(
            getUrl(
              id
            ),

            buildPayload(
              args
            ),

            true
          );

        } catch (
          error
        ) {

          return rejectWithValue(
            normalizeError(
              error
            )
          );

        }

      }
    );


export const updatePlatformSupportStatus =
  createUpdateThunk(
    "platformSupport/status",

    config
      .platformSupportStatus,

    (
      args
    ) => ({
      status:
        args.status,
    })
  );


export const updatePlatformSupportPriority =
  createUpdateThunk(
    "platformSupport/priority",

    config
      .platformSupportPriority,

    (
      args
    ) => ({
      priority:
        args.priority,
    })
  );


export const updatePlatformSupportNotes =
  createUpdateThunk(
    "platformSupport/notes",

    config
      .platformSupportNotes,

    (
      args
    ) => ({
      internalNotes:
        args.internalNotes,
    })
  );


export const updatePlatformSupportResolution =
  createUpdateThunk(
    "platformSupport/resolution",

    config
      .platformSupportResolution,

    (
      args
    ) => ({
      resolution:
        args.resolution,
    })
  );


const slice =
  createSlice({
    name:
      "platformSupport",

    initialState,

    reducers: {
      setPlatformSupportFilters(
        state,
        action
      ) {

        state.filters = {
          ...state.filters,

          ...(
            action.payload ||
            {}
          ),
        };

      },


      clearSelectedPlatformSupport(
        state
      ) {

        state.selectedTicket =
          null;

      },
    },

    extraReducers:
      (
        builder
      ) => {

        builder
          .addCase(
            fetchPlatformSupportTickets
              .pending,
            (
              state
            ) => {

              state.listLoading =
                true;

              state.error =
                null;

            }
          )
          .addCase(
            fetchPlatformSupportTickets
              .fulfilled,
            (
              state,
              action
            ) => {

              state.listLoading =
                false;

              state.tickets =
                Array.isArray(
                  action.payload
                    ?.data
                )
                  ?
                  action.payload
                    .data
                  :
                  [];

              state.pagination = {
                ...state.pagination,

                ...(
                  action.payload
                    ?.pagination ||
                  {}
                ),
              };

            }
          )
          .addCase(
            fetchPlatformSupportTickets
              .rejected,
            (
              state,
              action
            ) => {

              state.listLoading =
                false;

              state.error =
                action.payload;

            }
          );


        builder
          .addCase(
            fetchPlatformSupportSummary
              .fulfilled,
            (
              state,
              action
            ) => {

              state.summary = {
                ...state.summary,

                ...(
                  action.payload
                    ?.data ||
                  {}
                ),
              };

            }
          );


        builder
          .addCase(
            fetchPlatformSupportFilters
              .fulfilled,
            (
              state,
              action
            ) => {

              const data =
                action.payload
                  ?.data ||
                {};


              state.filterOptions = {
                statuses:
                  Array.isArray(
                    data.statuses
                  )
                    ?
                    data.statuses
                    :
                    [],

                priorities:
                  Array.isArray(
                    data.priorities
                  )
                    ?
                    data.priorities
                    :
                    [],

                categories:
                  Array.isArray(
                    data.categories
                  )
                    ?
                    data.categories
                    :
                    [],

                tenants:
                  Array.isArray(
                    data.tenants
                  )
                    ?
                    data.tenants
                    :
                    [],
              };

            }
          );


        builder
          .addCase(
            fetchPlatformSupportById
              .pending,
            (
              state
            ) => {

              state.detailsLoading =
                true;

            }
          )
          .addCase(
            fetchPlatformSupportById
              .fulfilled,
            (
              state,
              action
            ) => {

              state.detailsLoading =
                false;

              state.selectedTicket =
                action.payload
                  ?.data ||
                null;

            }
          );


        [
          updatePlatformSupportStatus,
          updatePlatformSupportPriority,
          updatePlatformSupportNotes,
          updatePlatformSupportResolution,
        ].forEach(
          (
            thunk
          ) => {

            builder
              .addCase(
                thunk.pending,
                (
                  state
                ) => {

                  state.actionLoading =
                    true;

                  state.error =
                    null;

                }
              )
              .addCase(
                thunk.fulfilled,
                (
                  state,
                  action
                ) => {

                  state.actionLoading =
                    false;


                  const updated =
                    action.payload
                      ?.data;


                  if (
                    !updated
                  ) {

                    return;

                  }


                  const id =
                    String(
                      updated._id ||
                      updated.id ||
                      ""
                    );


                  state.tickets =
                    state.tickets.map(
                      (
                        ticket
                      ) =>
                        String(
                          ticket._id ||
                          ticket.id ||
                          ""
                        ) ===
                        id
                          ?
                          updated
                          :
                          ticket
                    );


                  if (
                    String(
                      state.selectedTicket
                        ?._id ||
                      state.selectedTicket
                        ?.id ||
                      ""
                    ) ===
                    id
                  ) {

                    state.selectedTicket =
                      updated;

                  }

                }
              )
              .addCase(
                thunk.rejected,
                (
                  state,
                  action
                ) => {

                  state.actionLoading =
                    false;

                  state.error =
                    action.payload;

                }
              );

          }
        );

      },
  });


export const {
  setPlatformSupportFilters,
  clearSelectedPlatformSupport,
} =
  slice.actions;


export const selectPlatformSupportState =
  (
    state
  ) =>
    state.platformSupport ||
    initialState;


export default
  slice.reducer;
